export default __webpack_public_path__ + "static/react-testing-library-0c2c01f6cc6a09fb22613e98748f3948.svg";